import { skipToken } from "@reduxjs/toolkit/query";
import type { FC } from "react";
import {
  useGetKnowledgeBaseAttachmentWithContentQuery,
  useGetKnowledgeBaseQuery,
} from "../../../api/entities/knowledgeBase.js";
import { renderCrumbLabel } from "../../../app/navigation/crumbLabel.js";

/** Breadcrumb label for the knowledge base details page. */
export const KnowledgeBaseNameCrumbLabel: FC<{
  knowledgeBaseId: string | undefined;
}> = ({ knowledgeBaseId }) => {
  const result = useGetKnowledgeBaseQuery(knowledgeBaseId ?? skipToken);
  return renderCrumbLabel({
    hasValidId: knowledgeBaseId !== undefined,
    result,
    buildText: (knowledgeBase) => knowledgeBase.name,
    fallbackText: "Knowledge base",
  });
};

interface KnowledgeBaseAttachmentNameCrumbLabelProps {
  knowledgeBaseId: string | undefined;
  attachmentId: string | undefined;
}

/** Breadcrumb label for a knowledge base document. */
export const KnowledgeBaseAttachmentNameCrumbLabel: FC<
  KnowledgeBaseAttachmentNameCrumbLabelProps
> = (props) => {
  const { knowledgeBaseId, attachmentId } = props;
  const hasValidIds =
    knowledgeBaseId !== undefined && attachmentId !== undefined;
  const result = useGetKnowledgeBaseAttachmentWithContentQuery(
    hasValidIds ? { knowledgeBaseId, attachmentId } : skipToken,
  );

  return renderCrumbLabel({
    hasValidId: hasValidIds,
    result,
    buildText: (attachment) =>
      attachment.title || attachment.file_name || "Untitled document",
    fallbackText: "Document",
  });
};
